export const YEAR_INCORPORATED_MAX_LENGTH = 4;
export const DISABLED_OWNER_EMAIL_TOOLTIP_TITLE = 'You will be able to change users email on User Management page';
export const ANNUAL_REVENUE_AND_UNITS_SOLD_MAX_VALUE = 1000000000;
